import { useQuery } from '@tanstack/react-query';
import type { AuditEvent, SettingsResponse, SystemStatus } from '@contracts/system';
import { api } from '../lib/api';

export function useSystemStatus() {
  return useQuery({
    queryKey: ['system-status'],
    queryFn: () => api.get<SystemStatus>('/api/v1/system/status'),
    refetchInterval: 5000,
  });
}

export function useAuditEvents(limit = 50) {
  return useQuery({
    queryKey: ['audit', limit],
    queryFn: () => api.get<{ events: AuditEvent[] }>(`/api/v1/audit/events?limit=${limit}`),
    refetchInterval: 10_000,
  });
}

export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<SettingsResponse>('/api/v1/settings'),
  });
}
